import type { AnnounceBannerItem } from "@/features/announce/api/announceClient";

/** 初回取得・retry待ちだけskeletonを表示し、空状態の確定後は枠を畳む。 */
export function shouldShowAnnounceBannerSkeleton(
  banners: readonly AnnounceBannerItem[] | undefined,
  isError: boolean,
): boolean {
  return banners === undefined && !isError;
}

/**
 * 表示すべきバナーを1件選ぶ。並び順は`GET /api/v1/banner`側で確定済み
 * （`pinned_order`昇順→公開日時降順。`docs/frontend-integration/README.md` 1.2）
 * のため、フロント側では既読(dismiss済み)を除いた先頭を採用するだけでよい。
 */
export function selectVisibleBanner(
  banners: readonly AnnounceBannerItem[],
  isDismissed: (id: number) => boolean,
): AnnounceBannerItem | null {
  return banners.find((banner) => !isDismissed(banner.id)) ?? null;
}
